import { render, staticRenderFns } from "./AlertNotificationBehavior.global.vue?vue&type=template&id=7b0511a8&lang=pug&"
import script from "./AlertNotificationBehavior.global.vue?vue&type=script&lang=ts&"
export * from "./AlertNotificationBehavior.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports